import React, { useEffect, useRef, useState } from "react";
import { Form, Spin } from "antd";
// import "./DetailElectrocardiography.scss";

import { useAppDispatch, useAppSelector } from "redux/hooks";
import { TEN_PHONG, tabKeys } from "types/enums";
import { setActiveKey, setButtonsHeader } from "redux/reducer/common";

import PatientInfo, { PatientInfoRef } from "./PatientInfo/PatientInfo";
import Notification from "components/common/notification/notification";
import { setDataDiagnose, setIdDiagnose } from "redux/reducer/diagnose";

import {
  Cancel,
  Completed,
  NextPatient,
  Pause,
  Save,
  SaveAndPrint,
} from "pages/Refractive/InforDetails/config";
import moment from "moment";
import {
  setDataElectrocardiography,
  setDetailprintElectro,
  setElectroRef,
  setPatientRef,
} from "redux/reducer/electrocardiography";
import electrocardiographyService from "api/electrocardiography";
import ElectrocardiographyInfo, {
  ElectrocardiographyInfoRef,
} from "./ElectrocardiographyInfo/ElectrocardiographyInfo";
import { ModalCustom, StepInfo } from "components/common";
import PrintElectroPrintModal from "components/common/PrintReceipt/ElectroPrintModal/ElectroPrintModal";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";
import AlertModal from "components/common/AlertModal/AlertModal";

const DetailElectrocardiography = () => {
  const detailElectrocardiography = useAppSelector(
    (e) => e.electrocardiography.data
  );
  const electroRef = useRef<any>();
  const [listButton, setListButton] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const activeKey = useAppSelector((state) => state.common.activeTab);
  // const modalAlertRef = useRef<any>();

  const idElectrocardiography = useAppSelector(
    (e) => e.electrocardiography.idElectrocardiography
  );

  const patientInfoRef = useRef<PatientInfoRef>(null);
  const electrocardiographyInfoRef = useRef<ElectrocardiographyInfoRef>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(setPatientRef(patientInfoRef.current));
  }, [patientInfoRef]);

  useEffect(() => {
    dispatch(setElectroRef(electrocardiographyInfoRef.current));
  }, [electrocardiographyInfoRef]);

  const getDetailsElectrocardiographyById = async (id) => {
    setLoading(true);

    try {
      const res =
        await electrocardiographyService.getDetailsElectrocardiographyById(id);
      // dispatchCurrentRoom(dispatch, res?.trangThai, TEN_PHONG.phong_chup_mi_mat);

      if (res?.trangThai === 1) {
        const newRes = postStatusDiagnoseForm(2);
        dispatch(setDataElectrocardiography(newRes));
      } else dispatch(setDataElectrocardiography(res));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
    }
  };

  const postStatusDiagnoseForm = async (trangThai?, status?, dis?) => {
    setLoading(true);
    try {
      const params = {
        id: idElectrocardiography,
        trangThai: trangThai,
      };
      const res =
        await electrocardiographyService.updateStatusElectrocardiography(
          params
        );

      dispatch(setDataElectrocardiography(res));

      setLoading(false);
      if (trangThai != 2) {
        Notification("success", `Cập nhật trạng thái ${status} thành công`);
        dis && dispatch(setActiveKey(tabKeys.ELECTROCARDIOGRAPHY.LIST_PATIENT));
      }
    } catch (error) {
      setLoading(false);

      Notification("error", `Cập nhật trạng thái ${status} không thành công`);
    }
  };

  const handleComplete = async () => {
    // const patientInfo = patientInfoRef.current?.getFormValue();
    // if (patientInfo?.ngayTao) {
    //   modalAlertRef.current.openModal();
    //   setLoading(false);
    //   return;
    // }
    await postStatusDiagnoseForm(3, "hoàn thành", true);
  };

  const handleSave = async () => {
    setLoading(true);
    // await changeStatusDetailDiagnose(3);
    const patientInfo = patientInfoRef.current?.getFormValue();
    const newPatientInfo = {
      ...patientInfo,
      ngayTao: moment(patientInfo.ngayTao).format(),
      thoiGianChiDinh: patientInfo?.thoiGianChiDinh._i,
    };
    const electrocardiographyInfo =
      electrocardiographyInfoRef.current?.getFormValue();

    const newData = {
      id: idElectrocardiography,
      ...newPatientInfo,
      ...electrocardiographyInfo,
    };
    try {
      const res = await electrocardiographyService.updateDetails(newData);
      dispatch(setDataElectrocardiography(res));
      setLoading(false);
      Notification("success", "Lưu dữ liệu thành công");
    } catch (error) {
      Notification("error", "Lưu dữ liệu thất bại");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (idElectrocardiography === null) {
      dispatch(setActiveKey(tabKeys.ELECTROCARDIOGRAPHY.LIST_PATIENT));
    }
  }, [idElectrocardiography]);

  //print
  const getPrintElecto = async () => {
    if (idElectrocardiography != null) {
      const res = await electrocardiographyService.getDetailPrintElectro(
        idElectrocardiography
      );
      dispatch(setDetailprintElectro(res));
    } else Notification("error", "Không có thông tin phiếu in");
  };
  const handleSaveAndPrint = async () => {
    await handleSave();
    getPrintElecto();
    electroRef.current.openModal();
  };

  const handleNextPatient = async () => {
    setLoading(true);
    try {
      const res = await electrocardiographyService.nextPatientById();
      setLoading(false);
    } catch (error) {
      setLoading(false);

      Notification("error", error);
    }
  };
  const handlePause = async () => {
    if (detailElectrocardiography?.trangThai == 2) {
      await postStatusDiagnoseForm(1, "chờ thực hiện", true);
    } else {
      Notification(
        "warning",
        "Chỉ tạm dừng khi phiếu ở trạng thái Đang thực hiện"
      );
    }
  };

  const handleCancel = async () => {
    await postStatusDiagnoseForm(6, "hủy khám", true);
  };

  useEffect(() => {
    if (activeKey != tabKeys.ELECTROCARDIOGRAPHY.DETAIL_INFO_ELECTRO) {
      dispatch(setButtonsHeader([]));
      dispatch(setIdDiagnose(null));
    } else {
      getDetailsElectrocardiographyById(idElectrocardiography);
    }
  }, [activeKey]);

  useEffect(() => {
    if (
      listButton.length > 0 &&
      activeKey == tabKeys.ELECTROCARDIOGRAPHY.DETAIL_INFO_ELECTRO
    ) {
      dispatch(setButtonsHeader(listButton));
    }
  }, [listButton]);

  useEffect(() => {
    if (activeKey == tabKeys.ELECTROCARDIOGRAPHY.DETAIL_INFO_ELECTRO) {
      dispatch(setButtonsHeader(listButton));
    }
  }, [activeKey]);

  useEffect(() => {
    if (detailElectrocardiography?.trangThai == 3) {
      setListButton([
        Save(handleSave),
        SaveAndPrint(handleSaveAndPrint, "Lưu và in"),
        Completed(handleComplete, "Hoàn thành ĐT"),
        // NextPatient(handleNextPatient),
        Pause(handlePause),
      ]);
    } else if (detailElectrocardiography?.trangThai == 6) {
      setListButton([
        Save(handleSave),
        SaveAndPrint(handleSaveAndPrint, "Lưu và in"),
        // NextPatient(handleNextPatient),
        Cancel(handleCancel),
        Pause(handlePause),
      ]);
    } else
      setListButton([
        Save(handleSave),
        SaveAndPrint(handleSaveAndPrint, "Lưu và in"),
        Completed(handleComplete, "Hoàn thành ĐT"),
        // NextPatient(handleNextPatient),
        Cancel(handleCancel),
        Pause(handlePause),
      ]);
  }, [detailElectrocardiography]);
  //check xem có đủ api chưa?
  useEffect(() => {
    CheckNullApi();
  }, []);
  return (
    <Spin spinning={loading}>
      <div className="detail-diagnose">
        <div className="container">
          <div className="header">Thông tin bệnh nhân</div>
          <div className="container-main">
            <PatientInfo
              detailElectrocardiography={detailElectrocardiography}
              electrocardiographyInfoRef={electrocardiographyInfoRef}
              ref={patientInfoRef}
            />
          </div>
        </div>

        <div className="container">
          <StepInfo />
        </div>

        <div className="container">
          <div className="header">Thông tin điện tim</div>
          <ElectrocardiographyInfo
            electrocardiographyInfo={detailElectrocardiography}
            ref={electrocardiographyInfoRef}
          />
        </div>
        <ModalCustom ref={electroRef} width={900}>
          <PrintElectroPrintModal />
        </ModalCustom>
      </div>
      {/* Cảnh báo quá hạn ngày */}
      {/* <ModalCustom ref={modalAlertRef} width={600} title={"Cảnh báo"}>
        <AlertModal
          message={
            "Đã quá hạn hoàn thành cho phiếu khám. Vui lòng chọn hoàn thành khám chữa bệnh để hoàn thành phiếu!"
          }
        />
      </ModalCustom> */}
    </Spin>
  );
};
export default DetailElectrocardiography;
